import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { Navbar } from "./components/Navbar";
import { Inici } from "./components/Inici";
import { Escrits } from "./components/Escrits";
import { Horari } from "./components/Horari";
import { Objectius } from "./components/Objectius";
import { Login } from "./components/Login";

export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    // Check if user is already authenticated
    const auth = localStorage.getItem('authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <BrowserRouter>
      <Navbar />
      <main className="pt-16">
        <Routes>
          <Route path="/" element={<Inici />} />
          <Route path="/escrits" element={<Escrits />} />
          <Route path="/horari" element={<Horari />} />
          <Route path="/objectius" element={<Objectius />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
